import React, {forwardRef, useContext, useEffect, useRef, useState} from 'react';
import _axios from "../../../httpService";
import Loader from "../../Loader";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import {useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../utils/utilsData";
import "./CostAndBenefit.scss";
import BalanceSheetData from "./BalanceSheetDataPrint";
import BalanceSheetDataPrint from "./BalanceSheetDataPrint";
import CostAndProfitDataPrint from "./CostAndProfitDataPrint";


const DUMMY_DATA = {
  "right": [{
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  }, {
    "mainTitle": "دارایی جاری", "data": [{
      "title": "موجودی نقد و بانک", "remaining": "1044069935"
    }, {
      "title": "حساب ها و اسناد دریافتنی تجاری", "remaining": "11130000"
    }, {
      "title": "سایر حساب ها و اسناد دریافتنی", "remaining": "11781"
    }, {
      "title": "موجودی مواد و کالا", "remaining": "873912587"
    }]
  },], "left": [{
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  }, {
    "mainTitle": "بدهی جاری", "data": [{
      "title": "حساب ها و اسناد پرداختنی تجاری", "remaining": "(1509383381)"
    }]
  },]
}

const CostAndBenefit = () => {


  const myLocation = useLocation();
  const [whereIsHe, setWhereIsHe] = useState('')


  const [data, setData] = useState({})
  useEffect(() => {

    let splitUrl = myLocation.pathname.split('/');
    let urlPathname = splitUrl[splitUrl.length - 1];

    // constAndBenefit   OR  positionStatement
    let request =
      urlPathname === 'constAndBenefit' ? 'costAndProfit' :
        urlPathname === 'positionStatement' ? 'balanceSheet' : '';

    setWhereIsHe(request)
    _axios.get(prefixUrl() + "/accountingBalanceSheet/?request=" + request)
      .then(res => {
        if (res.data.status) {
          // res.data.data = DUMMY_DATA
          setData(res.data)
        } else {
          toast.error(res.data.message)
        }

      }).catch()


    return () => {
      setData({})
    }
  }, [myLocation])


  const myRef = useRef();
  return (<>
    <div
      // className={"printBalanceBenefit"}
      style={{
        width: "100%", height: "85vh", overflow: "scroll",
      }}
    >
      <div className={'block text-center'}>
        <ReactToPrint
          content={() => myRef.current}

        >
          <PrintContextConsumer>
            {({handlePrint}) => (<button
              id={"printButton"}
              className={"btnCustom btnSubmit"}
              onClick={handlePrint}
            >
              چاپ
            </button>)}
          </PrintContextConsumer>
        </ReactToPrint>
      </div>
      <div
        style={{
          width: "210mm", margin: "0 auto",
        }} className={"mt-3"}>
        {whereIsHe === 'balanceSheet' ?
          <>
            {Object.keys(data).length > 0 ? <BalanceSheetDataPrint data={data} ref={myRef}/> : <Loader/>}

          </>
          :
          whereIsHe === 'costAndProfit' ?
            <>
              {Object.keys(data).length > 0 ? <CostAndProfitDataPrint data={data} ref={myRef}/> : <Loader/>}
            </>
            :
            <></>
        }
       </div>
    </div>
  </>);


};

export default CostAndBenefit;
